import React from 'react';
import { Button, Avatar } from '@framework-controls/core';
import css from './CalendarSelectBtn.module.scss';
import classNames from 'classnames';
import { ButtonIds } from '../CalendarSelect';
import { strings } from 'src/localization';
import NoProfile from 'src/content/icons/Profile2.svg';
import NoProfileWhite from 'src/content/icons/ProfileWhite.svg';
import { IconProfile2 } from 'src/content/icons';

interface IProps {
    id: ButtonIds;
    label: string;
    icon: React.ReactElement;
    selected: boolean;
    theme: string;
    advisorURL: string;
    advisorName: string;
    onClick: (id: ButtonIds, e: any) => void;
}

const CalendarSelectBtn = (props: IProps) => {
    const btnClassName = classNames(
        css.calBtn,
        {
            [css.calBtnChecked]: props.selected,
            [css.calBtnCS]: props.theme === 'colorSensitive',
            [css.calBtnCA]: props.theme === 'cadillac',
            [css.calBtnCV]: props.theme === 'chevrolet' || props.theme === 'mercedesBenz',
            [css.calBtnHonda]: props.theme === 'honda',
            [css.calBtnHyundai]: props.theme === 'hyundai',
            [css.calBtnBuick]: props.theme === 'buick',
            [css.calBtnBMW]: props.theme === 'bmw',
            [css.calBtnFord]: props.theme === 'ford',
            [css.calBtnIN]: props.theme === 'infiniti',
            [css.calBtnMazda]: props.theme === 'mazda',
            [css.calBtnGenesis]: props.theme === 'genesis',
            [css.calBtnAcura]: props.theme === 'acura',
        },
    );

    const onClick = (e: any) => {
        props.onClick(props.id, e);
    };

    /* checks to see if we are on the advisor tab. If so we take the advisor image
    URL and use it to make an Avatar component for the tab */
    let avatar = <Avatar/>;
    if (props.id === 'advSel') {
        let image = props.advisorURL;
        switch (image){
            case '':
            case undefined:
                image = NoProfile;
                break;
            default:
                break;
        }

        const AdvImgAltTag = props.advisorName + ' ' + strings.Photo;
        let avatarColor: 'default' | 'primary' | 'secondary' | 'contrast' | 'completed' | 'blank' = 'blank';
        if (props.theme === 'colorSensitive') {
            avatarColor = 'primary';
            image= NoProfileWhite;
        }
        if (!props.selected && props.theme === 'toyotaSPM') {
            avatarColor = 'contrast';
        }
        if (!props.advisorURL) {
            if (props.selected && props.theme === 'toyotaSPM') {
                avatarColor = 'primary';
                image= NoProfileWhite;
            }
        }
        if (props.selected && props.theme === 'cadillac') {
            image = NoProfileWhite;
        }
        if (props.theme === 'infiniti') {
            avatarColor = 'contrast';
        }
        avatar = <Avatar
            elevation={0}
            color={avatarColor}
            borderThickness={0}
            src={image}
            alt={AdvImgAltTag}
        />;

        if (props.theme === 'hyundai' && (image === NoProfile || image === NoProfileWhite)) {
            const avatarHyundaiClass = props.selected ? css.avatarSelectedHyundai : css.avatarHyundai;
            avatar = <IconProfile2 className={avatarHyundaiClass} />;
        }
    }

    return (
        <div className={btnClassName}>
            <Button
                id={props.id + 'Btn'}
                onClick={onClick}
                variant='calBtn'
                disableRipple
                type={'text'}>
                <div className={css.btnArea}>
                    <div className={css.contentsIconDiv}>
                        <div className={css.calBtnContents}>
                            <div className={css.avatar}>
                                {props.id === 'advSel' ? avatar : props.icon}
                            </div>
                        </div>
                    </div>
                    <div className={css.contentsTitleDiv}>
                        <h3 className={css.calBtnContents}>{props.label}</h3>
                    </div>
                </div>
            </Button>
        </div>
    );
};

export default CalendarSelectBtn;